import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { BankAccountInstruction } from '../../Models/Domains/Instructions/BankAccountInstruction';

declare var IS_RUNNING_IN_APP_POOL;

export class BankAccountInstructionClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(model: BankAccountInstruction): Promise<BankAccountInstruction, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/BankAccount/BankAccountInstruction/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { model: model }

    return AjaxWrapper.post<BankAccountInstruction, any>(url, data);
  }
  public delete(model: BankAccountInstruction): Promise<BankAccountInstruction, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/BankAccount/BankAccountInstruction/Delete';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { model: model }

    return AjaxWrapper.post<BankAccountInstruction, any>(url, data);
  }
}

